import { render } from "./StatisticDetailedAmounts.vue?vue&type=template&id=c614bf70&ts=true"
import script from "./StatisticDetailedAmounts.vue?vue&type=script&lang=ts"
export * from "./StatisticDetailedAmounts.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__